import { data } from '../../svg/Star/data';
import { makeIcon } from '../makeIcon';

export const Star = makeIcon(data, 'star', 'Star');

export default Star;
